import { displayToast } from "../../../../helpers/notification";
import { StoreSettingTypes as Type } from "../../../types/store";


export function getCSVStoreListRequest(body: any) {
  return {
    type: Type.GET_CSV_STORE_LIST_REQUEST,
    body: body
  };
}

export function getCSVStoreListRequestSuccess(data: any) {
  return {
    type: Type.GET_CSV_STORE_LIST_REQUEST_SUCCESS,
    payload: data,
  };
}

export function getCSVStoreListRequestFailure(error: any) {
  try {
    if (
      error.response &&
      error.response.data &&
      error.response.data.message &&
      error.response.data.message.length > 0
    ) {
      if (Array.isArray(error.response.data.message))
        displayToast('ERROR', error.response.data.message[0]);
      else displayToast('ERROR', error.response.data.message);
    } else {
      displayToast('ERROR', error.message);
    }
  } catch (e) {
    displayToast('ERROR', error.message);
  }
  return {
    type: Type.GET_CSV_STORE_LIST_REQUEST_FAILURE,
    error: error,
  };
}